module.exports = __webpack_public_path__ + "static/media/google-button.e32c22a5.png";